module.exports = __webpack_public_path__ + "static/img/555.0f06aa6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/en/btn2/555.jpg
// module id = zOe/
// module chunks = 0